module.exports = "/build/images/refresh.svg?3a3db770c916b032ae694d0eb4aa4d31";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/refresh.svg
// module id = 2446
// module chunks = 0